export default __webpack_public_path__ + "static/menu-dont-light-58fcb1846ef06a492a6b036dea29bfa6c533046d8c42ba4e63080cc356b136cf.png";